module.exports = __webpack_public_path__ + "static/media/lock-outline.1b8e00a6.svg";